var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5292_30334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.000976562C7.178 0.000976562 0 7.17898 0 16.001V31.001C0 31.553 0.448 32.001 1 32.001H16C24.822 32.001 32 24.823 32 16.001C32 7.17898 24.822 0.000976562 16 0.000976562Z",
    fill: "#00284F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88574 12.7959C10.9027 13.4923 11.57 14.6621 11.57 15.9877C11.57 17.3134 10.9027 18.4832 9.88574 19.1796",
    stroke: "white",
    strokeWidth: 1.48101,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9712 10.5264C15.5856 11.7992 16.6219 13.7726 16.6219 15.988C16.6219 18.2033 15.5856 20.1767 13.9712 21.4495",
    stroke: "white",
    strokeWidth: 1.48101,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2046 7.65332C20.0496 9.33962 21.9569 12.4411 21.9569 15.988C21.9569 19.535 20.0496 22.6365 17.2046 24.3228",
    stroke: "white",
    strokeWidth: 1.48101,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5292_30334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/app-logo.cb57ebc73b7d4b6c588950ac728950d7.svg";
export { ForwardRef as ReactComponent };